import axios from 'axios';
import { API_URL} from 'constantes/constantes';

export default async function getMedallero(seccion) {
    const BASE_PATH = API_URL;

    const apiURL = `${BASE_PATH}${seccion}/medal_standings.json`;

    const config = {
        method: 'get',
        url: apiURL,
        timeout: 25000,
        withCredentials: false,
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json; charset=utf-8'
        }
    }

    return await axios(config)
        .then(res => {
            const {
                data,
                status
            } = res

            if (status === 200) {
                    return { data }
            }
            return []
        })
}